import styled from "styled-components"

export const Background = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: ${({ theme }) => theme.area.highBg || '#777'};
`

export const Card = styled.section`
    background: ${({ theme }) => theme.area?.background || '#fff'};
    border: 1px solid ${({ theme }) => theme.border?.color || '#e5e7eb'};
    border-radius: 0.75rem;
    padding: 2rem;
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`

export const Title = styled.h2`
    margin: 0;
    color: ${({ theme }) => theme.font?.color || '#888'};
`

export const Subtitle = styled.p`
    margin: 0;
    font-size: 1rem;
    color: ${({ theme }) => theme.font?.muted || '#6b7280'};
`

export const Message = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.font?.muted || '#6b7280'};
`

export const IconWrapper = styled.div`
    font-size: 2.5rem;
    color: ${({ theme }) => theme.btn?.primary || '#2563eb'};
    line-height: 1;
`

export const Button = styled.button`
    width: 100%;
    padding: 0.75rem 1rem;
    background: ${({ theme }) => theme.btn?.primary || '#2563eb'};
    color: #fff;
    border: none;
    border-radius: 0.5rem;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`

export const Input = styled.input`
    width: 100%;
    padding: 0.6rem 0.75rem;
    border: 1px solid ${({ theme }) => theme.border?.color || '#d1d5db'};
    border-radius: 0.5rem;
    font-size: 1rem;
    background: transparent;
    color: inherit;
    box-sizing: border-box;
`

export const Label = styled.label`
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    font-size: 0.9rem;
`

export const ErrorMsg = styled.p`
    color: indianred;
    margin: 0;
    font-size: 0.875rem;
`
